import { Grid, Typography, Box, LinearProgress, Button, Divider, Dialog, DialogTitle, DialogContent, DialogActions, TextField, useMediaQuery, useTheme } from "@mui/material";
import "../Common/css/styles.css";
import man from "../Assets/Images/man2.png"
import woman from "../Assets/Images/woman.png"
import { useState } from "react";
import PrimaryInputField from "src/Components/InputFields";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import { resetStudentPassword } from "src/Services/user_api";
import soldier from "../Assets/Images/soldier.png"
import knight from "../Assets/Images/knight.png"
import emperor from "../Assets/Images/emperor.png"

export default function Profile() {
    const [gender, setGender] = useState(sessionStorage.getItem("gender"));
    const [name, setName] = useState(sessionStorage.getItem("username"));
    const programme = sessionStorage.getItem("programme") || "";
    const stream = sessionStorage.getItem("stream") || "";
    const subjects = JSON.parse(sessionStorage.getItem("subjects") || "[]");
    const freeCourses = JSON.parse(sessionStorage.getItem("freeCourses") || "[]");
    const totalAmount = sessionStorage.getItem("totalAmount") || "0";
    const dueAmount = sessionStorage.getItem("dueAmount") || "0";
    const dueInstallments = sessionStorage.getItem("dueInstallments") || "0";
    const expireDate = sessionStorage.getItem("expireDate") || "N/A";
    const spg = sessionStorage.getItem("spg") || "0.0";
    const badge = sessionStorage.getItem("badge") || "No Badge";

    // choose badge image
    const _badgeKey = String(badge).trim().toLowerCase();
    const badgeImg = (_badgeKey === "rookie" || _badgeKey === "soldier")
        ? soldier
        : (_badgeKey === "knight")
            ? knight
            : emperor;

    // safe formatted expiry for display: "YYYY-MM-DD - HH:MM:SS" or fallback to raw value
    const expiryDisplay = (() => {
        if (!expireDate || expireDate === "N/A") return "N/A";
        const parts = String(expireDate).split("T");
        if (parts.length < 2) return expireDate;
        const datePart = parts[0];
        const timePart = parts[1].split(".")[0] || parts[1];
        return `${datePart} - ${timePart}`;
    })();
    const [isLoading, setIsLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDescription, setAlertDescription] = useState("");
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");

    // numeric calculations for progress
    const total = parseFloat(totalAmount) || 0;
    const due = parseFloat(dueAmount) || 0;
    const paid = Math.max(0, total - due);
    const progress = total > 0 ? Math.round((paid / total) * 100) : 0;
    // change password dialog state
    const [changeOpen, setChangeOpen] = useState(false);
    const [cpEmail, setCpEmail] = useState(sessionStorage.getItem("email") || "");
    const [cpNew, setCpNew] = useState("");
    const [cpConfirm, setCpConfirm] = useState("");
    const [cpErrors, setCpErrors] = useState<{ email?: string; new?: string; confirm?: string }>({});
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const userType = sessionStorage.getItem("userType") || ""

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const handleChangePassword = async () => {
        if (cpEmail.trim() === "" || cpNew.trim() === "" || cpConfirm.trim() === "") {
            showAlert("Please fill in all fields", "warning");
            return;
        }
        if (cpNew !== cpConfirm) {
            showAlert("New password and confirm password do not match", "warning");
            return;
        }

        setChangeOpen(false);
        setCpEmail("");
        setCpNew("");
        setCpConfirm("");

        setIsLoading(true);
        try {
            await resetStudentPassword(sessionStorage.getItem("token") || "", cpEmail, cpNew);
            setIsLoading(false);
            showAlert("Password changed successfully", "success");

            setCpErrors({});
        } catch (error: any) {
            setIsLoading(false);
            showAlert(error.response.data.message === "User not found with the provided email. (Parameter 'user')" ? "User not found with the entered email." : "Error changing password", "error");
        }
    }

    return (
        <div className="comman-outer">
            <CustomAlert
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                description={alertDescription}
                type={alertType}
                timeout={3000}
            />
            <Spinner isLoading={isLoading} />
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <div className="profile-outer">
                        <div className="profile-banner">
                            <img className="profile-image" src={gender === "male" ? man : woman} alt="" />
                        </div>
                        <h2 className="profile-name">{name}</h2>

                        {/* New profile meta area */}
                        <div className="pf-profile-meta">
                            {(programme || stream) && (
                                <div className="pf-info-row">
                                    {programme && <div className="pf-info-item"><span className="pf-info-label">Programme:</span> <span className="pf-info-value">{programme}</span></div>}
                                    {stream && <div className="pf-info-item"><span className="pf-info-label">Stream:</span> <span className="pf-info-value">{stream}</span></div>}
                                </div>
                            )}

                            {Array.isArray(subjects) && subjects.length > 0 && (
                                <div className="pf-section">
                                    <div className="pf-section-title">Subjects</div>
                                    <div className="pf-badges">
                                        {subjects.map((s: any, i: number) => (
                                            <span key={i} className="pf-badge">{typeof s === "string" ? s : (s.name || s.subject || JSON.stringify(s))}</span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {Array.isArray(freeCourses) && freeCourses.length > 0 && (
                                <div className="pf-section">
                                    <div className="pf-section-title">Free Courses</div>
                                    <div className="pf-badges">
                                        {freeCourses.map((c: any, i: number) => (
                                            <span key={i} className="pf-badge pf-free">{typeof c === "string" ? c : (c.title || c.name || JSON.stringify(c))}</span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <Divider style={{ margin: "12px 0" }} />

                            {/* Change password button */}
                            {userType !== "PARENT" && (
                                <Button className="pf-change-password-button" onClick={() => setChangeOpen(true)}>Change Password</Button>
                            )}

                            {/* Change Password Dialog */}
                            <Dialog
                                open={changeOpen}
                                onClose={() => setChangeOpen(false)}
                                fullScreen={fullScreen}
                                aria-labelledby="change-password-title"
                                PaperProps={{ sx: { bgcolor: "#0d0d0d", color: "#fff", borderRadius: 2 } }}
                            >
                                <DialogTitle id="change-password-title">Change Password</DialogTitle>
                                <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 1, overflowX: "hidden", color: "black" }}>
                                    <PrimaryInputField
                                        placeholder="Enter your email"
                                        value={cpEmail}
                                        type="text"
                                        disabled={false}
                                        width="97%"
                                        size="small"
                                        onChange={(e: any) => setCpEmail(e.target.value)}
                                    />
                                    <PrimaryInputField
                                        placeholder="New Password"
                                        value={cpNew}
                                        onChange={(e) => setCpNew(e.target.value)}
                                        type="password"
                                        width="97%"
                                        size="small"
                                    />
                                    <PrimaryInputField
                                        placeholder="Confirm Password"
                                        value={cpConfirm}
                                        onChange={(e) => setCpConfirm(e.target.value)}
                                        type="password"
                                        width="97%"
                                        size="small"
                                    />
                                </DialogContent>
                                <DialogActions sx={{ px: 3, py: 2 }}>
                                    <Button onClick={() => setChangeOpen(false)} variant="outlined">Cancel</Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            handleChangePassword();
                                        }}
                                    >
                                        Save
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                        {/* end profile meta */}
                    </div>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {/* payment details card */}
                            <Box className="pf-payment-card">
                                <Typography variant="h6" className="pf-payment-title">Payment Details</Typography>

                                <Box className="pf-payment-row">
                                    <div>
                                        <Typography className="pf-payment-label">Total (LKR)</Typography>
                                        <Typography className="pf-payment-value">₨ {total.toFixed(2)}</Typography>
                                    </div>
                                    <div>
                                        <Typography className="pf-payment-label">Due (LKR)</Typography>
                                        <Typography className="pf-payment-value pf-due">₨ {due.toFixed(2)}</Typography>
                                    </div>
                                </Box>

                                <Box sx={{ mt: 1, mb: 1 }}>
                                    <Box className="pf-progress-row">
                                        <Typography variant="body2" className="pf-progress-text">Paid</Typography>
                                        <Typography variant="body2" className="pf-progress-percent">{progress}%</Typography>
                                    </Box>
                                    <LinearProgress className="pf-progress" variant="determinate" value={progress} />
                                </Box>

                                {dueInstallments !== "0" && due > 0 && (
                                    <Box className="pf-payment-row small" sx={{ mt: 1 }}>
                                        <div>
                                            <Typography className="pf-payment-label">Due Installments</Typography>
                                            <Typography className="pf-payment-value">{dueInstallments}</Typography>
                                        </div>
                                        <div>
                                            <Typography className="pf-payment-label">Expiry</Typography>
                                            <Typography className="pf-payment-value">{expiryDisplay}</Typography>
                                        </div>
                                    </Box>
                                )}

                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            {/* spg details card */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                    gap: 2,
                                    p: 2,
                                    borderRadius: 2,
                                    bgcolor: "#2c2b2bff",
                                }}
                            >
                                <Box
                                    component="img"
                                    src={badgeImg}
                                    alt={badge}
                                    sx={{
                                        width: { xs: 150, sm: 200, md: 200 },
                                        height: { xs: 150, sm: 200, md: 200 },
                                        objectFit: "contain",
                                    }}
                                />
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
                                    <Typography sx={{ fontSize: 18, color: "#aaa", fontWeight: 700 }}>SPG</Typography>
                                    <Typography sx={{ fontSize: 30, color: "#d3aa04", fontWeight: 800 }}>
                                        {(parseFloat(spg) || 0).toFixed(2)}
                                    </Typography>
                                    <Typography sx={{ fontSize: 13, color: "#fff" }}>
                                        <strong style={{ color: "#d9ae03" }}>Badge:</strong> {badge === "Rookie" ? "Soldier" : badge}
                                    </Typography>
                                    <Typography sx={{ fontSize: 13, color: "#fff" }}>
                                        <strong style={{ color: "#d9ae03" }}>Level:</strong> {badge === "Rookie" ? "1" : badge === "Soldier" ? "1" : badge === "Knight" ? "2" : "3"}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}